export const getHashIndex = (hash, max) => {
  let hashIndex = parseInt(hash.substr(1), 10);
  if (Number.isNaN(hashIndex) || hashIndex < 1) {
    hashIndex = 1;
  } else if (hashIndex > max) {
    hashIndex = max;
  }
  return hashIndex;
};
